import React from 'react';
import { Users } from 'lucide-react';
import { useTheme } from '../../../contexts/ThemeContext';
import MatchListView from './MatchListView';

const GroupStandingsPanel = ({
  groupStage,
  advancePerGroup,
  matchOrderOverrides,
  reorderRow,
  courts,
  sportType,
  tournamentMatchSettings,
  roundOverrides,
  rowOverrides,
  applyRoundOverride,
  applyRowOverride,
  filters,
  currentUserId,
  onClearFilters,
  tournamentVO,
  startScoring,
  openLiveGame,
  canManageThisSchedule,
  updateMatchSchedule,
  deleteMatchRow,
  assignMatchParticipants,
  addMatch,
  fetchAllParticipants,
  participantType,
}) => {
  const { theme } = useTheme();
  return (
    <div>
      <p className={`mb-4 text-sm ${theme.textSecondary}`}>
        Top {advancePerGroup} from each group advance to the knockout bracket. Pairings within a group are
        round robin — every participant in the group plays every other participant in the group once.
      </p>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        {groupStage.map((group) => {
          const listKey = `group:${group.label}`;
          return (
            <div key={group.label} className={`rounded-2xl border ${theme.border} ${theme.card} p-4`}>
              <div className="mb-3 flex items-center justify-between">
                <span className={`text-sm font-bold ${theme.text}`}>{group.label}</span>
                <span className={`flex items-center gap-1 text-xs ${theme.textMuted}`}>
                  <Users size={12} />
                  {group.participants.length}
                </span>
              </div>
              <div className="mb-4 flex flex-wrap gap-1.5">
                {group.participants.map((p) => (
                  <span
                    key={p.id}
                    className={`rounded-full px-2.5 py-1 text-xs font-medium ${theme.backgroundSecondary} ${theme.textSecondary}`}
                  >
                    {p.name}
                  </span>
                ))}
              </div>
              <MatchListView
                rounds={group.rounds}
                orderOverrides={matchOrderOverrides?.[listKey]}
                onReorderRow={(roundNumber, order) => reorderRow(listKey, roundNumber, order)}
                courts={courts}
                sportType={sportType}
                tournamentMatchSettings={tournamentMatchSettings}
                roundOverrides={roundOverrides?.[listKey]}
                rowOverrides={rowOverrides?.[listKey]}
                onApplyRoundOverride={(roundNumber, override, clearRowKeys, rowLiveDataIds) => applyRoundOverride(listKey, roundNumber, override, clearRowKeys, rowLiveDataIds)}
                onApplyRowOverride={(rowKey, override, liveData) => applyRowOverride(listKey, rowKey, override, liveData)}
                filters={filters}
                currentUserId={currentUserId}
                onClearFilters={onClearFilters}
                tournamentVO={tournamentVO}
                startScoring={startScoring}
                openLiveGame={openLiveGame}
                canManageThisSchedule={canManageThisSchedule}
                updateMatchSchedule={updateMatchSchedule}
                deleteMatchRow={deleteMatchRow}
                assignMatchParticipants={assignMatchParticipants}
                addMatch={addMatch}
                fetchAllParticipants={fetchAllParticipants}
                participantType={participantType}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GroupStandingsPanel;
